import { useCallback } from 'react';
import { Handle, Position } from '@xyflow/react';

const handleStyle = { top: 50,  };

export default function SerialOrchestrator({ data, isConnectable }) {

//   const onChange = useCallback((evt) => {
//     console.log(evt.target.value);
//   }, []);

  return (
    <div className="w-40 h-36 p-4 bg-white rounded-lg flex items-center justify-center border border-gray-200 relative">

        {/* <Handle
            type="target"
            position={Position.Top}
            id="a"
            style={{ ...handleStyle, width: 6, height: 6, borderRadius: '50%', backgroundColor: '#74b9ff'}}
            isConnectable={isConnectable}
        />

        <Handle
            type="target"
            position={Position.Top}
            id="b"
            isConnectable={isConnectable}
            style={{width: 6, height: 6, borderRadius: '50%', backgroundColor: '#74b9ff'}}
        />
 */}
        <Handle
            type="target"
            position={Position.Top}
            id="c"
            isConnectable={isConnectable}
            style={{ width: "50%", height: 6, borderRadius: '0', backgroundColor: '#ff7675' }}
        />

        <div className="text-center">
            Serial Orchestrator
        </div>

        {/* <Handle
            type="source"
            position={Position.Right}
            id="a"
            style={{ ...handleStyle, width: 6, height: 6, borderRadius: '50%', backgroundColor: '#74b9ff' }}
            isConnectable={isConnectable}
        /> */}

        <Handle
            type="source"
            position={Position.Right}
            id="b"
            isConnectable={isConnectable}
            style={{width: 6, height: "50%", borderRadius: '0', backgroundColor: '#74b9ff'}}
        />

        {/* <Handle
            type="source"
            position={Position.Right}
            id="c"
            isConnectable={isConnectable}
            style={{ top: 100, width: 6, height: 6, borderRadius: '50%', backgroundColor: '#74b9ff' }}
        /> */}

    </div>
)}


